import React, { useEffect, useState } from "react";
import { usersService, actifsService } from "../../services";
import { useAuth } from "../../utils/UserProvider";
import { useForm } from "react-hook-form";
import { CustomDialog, showToast } from "..";
import { Actif, User } from "../../interfaces";
import { MultiSelect } from "primereact/multiselect";
import { AWS_BUCKET_ENV,AWS_BUCKET_NAME } from "../../config/awsParams";

interface ModalAccessActifProps {
  modalIsOpenAcces: boolean;
  closeModalAcces: () => void;
  actif: Actif;
}

const ModalAccessActif = ({
  modalIsOpenAcces,
  closeModalAcces,
  actif,
}: ModalAccessActifProps) => {
  const [users, setUsers] = useState<User[]>([]);
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [selectedOptionsMembers, setSelectedOptionsMembers] = useState([]);
  const [optionsMembers, setOptionsMembers] = useState([]);
  const [loading, setLoading] = useState<boolean>(false);
  const { user } = useAuth();

  const {
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    const fetchUsers = async (user_id, client_id) => {
      try {
        setLoading(true);
        const response =
          await usersService.getAllUsersOFOrganisationSaufMeAndActif(
            user_id,
            client_id,
            actif.id
          );
        const mappedOptions = response?.map((user) => ({
          value: user.id,
          label: (
            <div className="flex space-x-2">
              <img
                className="object-cover w-5 h-5 rounded-full"
                src={user.photo_user}
              />
              <div className="text-left rtl:text-right">
                <h1 className="text-sm font-semibold text-gray-700 capitalize ">
                  {user.first_name + " " + user.last_name}
                </h1>
              </div>
            </div>
          ),
        }));
        setOptionsMembers(mappedOptions);
        setLoading(false);
        setUsers(response);
      } catch (e) {
        console.log("Error while fetching", e);
        setLoading(false);
      }
    };
    fetchUsers(user.id, user.client_id);
  }, [user]);

  const handleSelectChangeMember = (e) => {
    setSelectedOptionsMembers(e.value);
    // const selectedIds = selectedOptions.map((option) => option.value);
    // setSelectedMembers(selectedIds);
  };

  const onSubmit = async () => {
    try {
      const Data = {
        actif_id: actif.id,
        member_ids: selectedMembers,
      };
      setLoading(true);
      await actifsService.AssigneMembers(Data).then((response) => {
        setLoading(false);
        showToast("success", "Membres ajoutées avec succès");
        setTimeout(() => {
          window.location.reload();
        }, 2000);
        reset();
        closeModalAcces();
      });
    } catch (e) {
      console.log("Error while fetching", e);
    }
  };

  return (
    <CustomDialog
      header="Gérer l'accès - Inviter des membres"
      visible={modalIsOpenAcces}
      closeModalDialog={() => {
        closeModalAcces();
      }}
    >
      <div className="w-full h-full ">
        <div className="p-6 space-y-6">
          <span className=" text-gray-500 text-sm">
            Tous les membres d'actif ont accès à tous les fichiers.
          </span>
          <form onSubmit={handleSubmit(onSubmit)} encType="multipart/form-data">
            <div className="flex space-x-2">
              <MultiSelect
                className="my-3 border border-gray-300 text-gray-900 font-bold text-xl rounded-lg focus:ring-gexpertise-100 focus:border-gexpertise-200 w-full"
                placeholder="Sélectionner vos utilisateurs..."
                options={optionsMembers}
                value={selectedOptionsMembers}
                onChange={handleSelectChangeMember}
                name="id"
                filter
              />

              <button
                type="submit"
                className="text-white w-52 bg-gexpertise-100 hover:bg-gexpertise-200    font-normal rounded-md text-sm text-center  "
              >
                Envoyer invitation
              </button>
            </div>
          </form>
          <div>
            <div className="flex justify-between">
              <span className="text-gray-500 font-semibold">Accès</span>
            </div>
            {actif?.members?.map((member) => (
              <button
                key={member.id}
                className="flex justify-between w-full px-4 py-5 space-x-1 transition-colors duration-200  gap-x-2 hover:bg-gray-100 focus:outline-none"
              >
                <div className="flex space-x-4">
                  <img
                    className="object-cover w-10 h-10 rounded-full"
                    src={
                      member.photo_user
                        ? member.photo_user
                        : `ttps://${AWS_BUCKET_NAME}.s3.amazonaws.com/${AWS_BUCKET_ENV}/users_photos/profile.png`
                    }
                  />
                  <div className="text-left rtl:text-right">
                    <h1 className="text-md font-semibold text-gray-700 capitalize ">
                      {member.first_name + " " + member.last_name}
                    </h1>
                    <p className="text-sm text-gray-400 ">{member.email}</p>
                  </div>
                </div>
                {actif.interlocuteur_referent_id === member.id ? (
                  <span className=" text-lg   font-semibold flex mt-2 text-gexpertise-200">
                    Propriétaire
                  </span>
                ) : (
                  <span className=" text-lg   font-semibold flex mt-2 text-gexpertise-200">
                    Membre
                  </span>
                )}
              </button>
            ))}
          </div>
        </div>
      </div>
    </CustomDialog>
  );
};

export default ModalAccessActif;
